import { ProjectHelpdeskTasksKindEnum } from '@zaoblako/shared/modules/project/enum/project.helpdesk.tasks.kind.enum';
import { SubsKindEnum } from '@zaoblako/shared/modules/project/enum/subs.kind.enum';
import { ProjectState } from '@zaoblako/web/modules/project/components/project/card/models/project-state';

export const projectInitialState: ProjectState = {
  project: null,
  checklistsInfo: {
    checklists: [],
    loading: false
  },
  subprojectsInfo: {
    count: 0,
    projects: [],
    queryParams: {
      limit: 100,
      offset: 0,
      statusKind: SubsKindEnum.ACTIVE,
      listStyle: 'hierarchy'
    },
    loading: false,
    paginationLoading: false
  },
  helpdeskTasksInfo: {
    tasks: [],
    queryParams: {
      kind: ProjectHelpdeskTasksKindEnum.ALL
    },
    loading: false
  },
  dealsInfo: {
    deals: [],
    queryParams: {
      statusKind: SubsKindEnum.ALL
    },
    loading: false
  },
  filesInfo: {
    files: [],
    loading: false
  },
  panelsInfo: {
    actionsShow: true,
    checklistsShow: true,
    calendarChecklistsShow: false,
    subprojectsShow: true,
    helpdeskTasksShow: false,
    dealsShow: false,
    defaultsShow: false,
    additionalDetailsShow: true
  },
  subprojectDefaults: {
    defaults: null,
    loading: false
  },
  userGroups: [],
  clients: [],
  projectBreadcrumbs: []
};
